import { Avatar } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

const InitialsAvatar = ({ bgcolor = deepPurple[500], color = '#ffffff', size = 36, fontSize = 16, fontWeight = 600, children }) => {
  return <Avatar
    sx={{
      bgcolor: bgcolor,
      color: color,
      width: size,
      height: size,
      lineHeight: fontSize,
      borderRadius: "100%",
      fontSize: fontSize,
      fontWeight: fontWeight
    }}
    className={`!w-[${size}px] !h-[${size}px] m-0`}
  >
    {(children || "").split(" ").map(name => name[0]).join("").slice(0, 2).toUpperCase()}
  </Avatar>
}

export default InitialsAvatar;